import { FC } from "react";
import { BaseProps } from "./text";
import GText from "./GText";
import { css } from "@emotion/react";

interface Props {
  text?: string;
  once?: boolean;
  duration?: number;
}

const GTextVideo: FC<Props & BaseProps> = (props) => {
  const styles = css`
    & {
      position: relative;
      overflow: hidden;
    }

    & video {
      position: absolute;
      width: 99.5%;
      height: 95%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      object-fit: cover;
    }

    & h2 {
      position: relative;
      text-align: center;
      font-size: ${props.fontSize}px;
      margin: 0;
      color: ${props.background === "White" ? "#000" : "#fff"};
      background-color: ${props.background ?? "#fff"};
      z-index: 99;
      mix-blend-mode: ${props.background === "White" ? "screen" : "multiply"};
      backface-visibility: hidden;
    }
  `;

  return (
    <GText {...props}>
      <div css={styles}>
        <video autoPlay loop muted>
          <source src={props.filepath} type="video/mp4" />
        </video>
        <h2>{props.text}</h2>
      </div>
    </GText>
  );
};

GTextVideo.defaultProps = {
  text: "Subscribe to grooody",
  color: "#000",
  once: true,
  fontSize: 30,
  background: "White",
  filepath:
    "https://media.istockphoto.com/id/521343308/video/car-dash-camera-time-lapse-at-night-in-a-tunnel-on-the-highway.mp4?s=mp4-640x640-is&k=20&c=8g8Wzvkl_4zznIu4M7uGsj94PxbQXe47NvGZU3TTsuI=",
};

export default GTextVideo;

// We need to add the below in framer
/*
addPropertyControls(TextFadeIn, {
    text: {
        title: "Text",
        type: ControlType.String,
        defaultValue: "Subscribe to Grooody",
    },
    letterSpacing: {
        title: "Letter",
        type: ControlType.Number,
    },
    letterSpacing: {
        title: "Letter",
        type: ControlType.Number,
    },
    fontSize: {
        title: "Font Size",
        type: ControlType.Number,
        defaultValue: 46,
    },
    fontFamily: {
        title: "Font Family",
        type: ControlType.Font,
        defaultValue: "Sigmar",
    },
    once: {
        title: "Once",
        type: ControlType.Boolean,
        defaultValue: true,
        description: "Run animation only once on page mount",
    },
     background: {
        title: "Background",
        type: ControlType.Enum,
        defaultValue: "White",
        segmentedControlDirection: "vertical",
        options: ["White", "Black"],
    },   
    filepath: {
        type: ControlType.File,
        allowedFileTypes: ["mov"],
        defaultValue: [
            "https://media.istockphoto.com/id/521343308/video/car-dash-camera-time-lapse-at-night-in-a-tunnel-on-the-highway.mp4?s=mp4-640x640-is&k=20&c=8g8Wzvkl_4zznIu4M7uGsj94PxbQXe47NvGZU3TTsuI=",
        ],
    },
})


*/
